<template>
  <div class="evaluate-wrap" :class="{'disabled': disabled}">
    <t-icon v-for="(starType, index) in itemClasses"
            :key="'evaluate-' + index"
            :size="size"
            class="evaluate-star"
            :class="$_getStarClass(starType)"
            :color="starType === 'on' ? color : ''"
            :type="$_getStarType(starType)" @click.native="$_onClick(index)"></t-icon>
  </div>
</template>

<script>
  const ON = 'on'
  const OFF = 'off'
  const HALF = 'half'
  export default {
    name: "evaluate",
    props: {
      colorClass: {
        type: String,
        default: ''
      },
      color: String,
      // totalStar: {
      //   type:  [ Number, String ],
      //   default: 5
      // },
      score: {
        type:  [ Number, String ],
        default: 0,
        validator: function (value) {
          // 这个值必须匹配下列字符串中的一个
          return 0 <= value && value <=5
        }
      },
      // half: Boolean,
      size: {
        type:  [ Number, String ],
        default: 20
      },
      disabled: Boolean
    },
    computed: {
      itemClasses() {
        let result = []
       // 四舍五入计算把分数换算成0.5的倍数
        let score = Math.floor(this.localScore * 2) / 2
        let intNum = Math.floor(score)
        // 是否需要半星
        let hasDecimal = this.localScore % 1 !== 0
        // 全星push到数组里面
        for (let i = 0; i < intNum; i++) {
          result.push(ON)
        }
        // 半星放到数组里面
        if (hasDecimal) {
          result.push(HALF)
        }
        // 灰色星星放到数组里面
        while (result.length < this.totalStar) {
          result.push(OFF)
        }
        return result
      }
    },
    data() {
      return {
        totalStar: 5,
        localScore: this.score
      }
    },
    methods: {
      $_getStarType(type){
        return type === 'half' ? 'star-half' : 'star'
      },
      $_getStarClass(type) {
        let classes = [type]
        return classes.concat(this.colorClass)
      },
      $_onClick(index) {
        if (this.disabled === true) {
          return
        }
        if (this.itemClasses[index] && this.itemClasses[index]==='on') {
          if(this.localScore > index + 1) {
            this.localScore = index + 1
          } else {
            this.localScore = 0
          }

        } else {
          this.localScore = index + 1
        }
        this.$emit('update:score', this.localScore)
      }
    }
  }
</script>

<style scoped>
 .evaluate-wrap .evaluate-star {
   margin-right: 4px;
   cursor: pointer;
 }
 .evaluate-wrap.disabled .evaluate-star {
   cursor: not-allowed;
 }
 .evaluate-wrap .evaluate-star.on, .evaluate-wrap .evaluate-star.half {
   color: #ffb717;
 }
 .evaluate-wrap .evaluate-star.off {
   color: #dddddd;
 }
</style>


// WEBPACK FOOTER //
// evaluate.vue?eb77b186